import apiClient from "../../../api/apiClient";

// ================= GET ALL =================
export const getWeightTestsApi =
  async (
    page: number,
    pageSize: number,
    search: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        "/weight-tests",
        {
          params: {
            pageNumber: page,
            pageSize,
            search,
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= GET BY ID =================
export const getWeightTestByIdApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        `/weight-tests/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= CREATE =================
export const createWeightTestApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.post(
        "/weight-tests",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= UPDATE =================
export const updateWeightTestApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.put(
        "/weight-tests",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= DELETE =================
export const deleteWeightTestApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.delete(
        `/weight-tests/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };